export const formatNumber = (v, settings) =>
  Number(v || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: settings?.thousands_separator !== false,
  });

export const formatMoney = (v, settings) => `$${formatNumber(v, settings)}`;
